import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Signature } from '../signature-box/signature-box.dto';

@Injectable({
    providedIn: 'root'
})

export class SigningHelperService {
    // Create a BehaviorSubject to hold the observable variable
    private signatureBase64: BehaviorSubject<Signature> = new BehaviorSubject<Signature>(null);

    // Expose the observable as a public property
    signatureBase64$: Observable<Signature> = this.signatureBase64.asObservable();

    // Create a BehaviorSubject to hold the observable variable
    private callFunction: BehaviorSubject<{assignedSignatureBox:boolean}> = new BehaviorSubject<{assignedSignatureBox:boolean}>({assignedSignatureBox:false});

    // Expose the observable as a public property
    callFunction$: Observable<{assignedSignatureBox:boolean}> = this.callFunction?.asObservable()

    private eventlisten = new BehaviorSubject<string>('');
    currentListen = this.eventlisten.asObservable();

    setCall(param) {
        this.callFunction.next(param);
    }


    setSignature(signature:Signature) {
        this.signatureBase64.next(signature);
    }

    updateListener(param) {
        this.eventlisten.next(param);
    }
}